var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditSquareblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.0441,
    height: 24,
    transform: "translate(0 0.351562)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6959 2.3619C18.1371 2.27199 19.5582 2.77147 20.6291 3.75046C21.6099 4.81936 22.1103 6.23789 22.0303 7.68639V17.0167C22.1203 18.4652 21.6099 19.8838 20.6391 20.9527C19.5683 21.9317 18.1371 22.4311 16.6959 22.3412H7.34834C5.89717 22.4311 4.47601 21.9317 3.40514 20.9527C2.42435 19.8838 1.92394 18.4652 2.01402 17.0167V7.68639C1.92394 6.23789 2.42435 4.81936 3.40514 3.75046C4.47601 2.77147 5.89717 2.27199 7.34834 2.3619H16.6959ZM11.0013 17.1965L17.7368 10.4535C18.3473 9.83417 18.3473 8.8352 17.7368 8.22583L16.4357 6.92717C15.8152 6.30782 14.8144 6.30782 14.1939 6.92717L13.5234 7.60647C13.4233 7.70637 13.4233 7.87619 13.5234 7.97609C13.5234 7.97609 15.1146 9.55446 15.1447 9.59441C15.2548 9.71429 15.3248 9.87413 15.3248 10.0539C15.3248 10.4136 15.0346 10.7133 14.6643 10.7133C14.4941 10.7133 14.334 10.6433 14.2239 10.5334L12.5526 8.87516C12.4725 8.79524 12.3324 8.79524 12.2523 8.87516L7.47845 13.6402C7.14818 13.9699 6.95803 14.4094 6.94802 14.8789L6.88797 17.2465C6.88797 17.3764 6.928 17.4962 7.01808 17.5861C7.10815 17.6761 7.22825 17.726 7.35835 17.726H9.71026C10.1906 17.726 10.651 17.5362 11.0013 17.1965Z",
    fill: "#8EC37A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSquareblue);
export default __webpack_public_path__ + "static/media/Edit Squareblue.c9720f947cdef7ea8f61adbb0bd3d1d6.svg";
export { ForwardRef as ReactComponent };